import baseUrl from './base';

export const printRecu = (id: number, mail = false) =>
  `${baseUrl}/editions/recus/${id}${mail ? '?mail=true' : ''}`;

export const printRelance = (id, job = false, mail = false) => {
  const params = [job && 'job=true', mail && 'mail=true'].filter(Boolean).join('&');

  return `${baseUrl}/editions/relances/${id}${params ? `?${params}` : ''}`;
};

// Aperçu des relances « avant date limite de paiement ».
// Endpoint dédié côté api-regie (défini) ; côté api-regie, l'appel au SERVICE_EDITION (WinDev)
// pour le rendu du document « avant » reste à brancher quand sa route sera connue.
export const printRelanceAvantEcheance = (id, job = false, mail = false) => {
  const params = [job && 'job=true', mail && 'mail=true'].filter(Boolean).join('&');

  return `${baseUrl}/editions/relances-avant-echeance/${id}${params ? `?${params}` : ''}`;
};

export const printBordereau = (id) => `${baseUrl}/editions/bordereaux-versements/${id}`;

/**
 * Type :
 * 0 = récapitulatif journalier par mode de règlement (arrêté mensuel).
 * 1 = récapitulatif par produit et par mode de règlement (arrêté mensuel).
 * 2 = récapitulatif journalier par produit (arrêté mensuel).
 * 3 = récapitulatif journalier par produit et par mode de règlement (arrêté mensuel).
 * 4 = récapitulatif par budget / produit / imputations (arrêté mensuel).
 * 5 = récapitulatif par produit et par mode de règlement (arrêté journalier).
 */
export const printRecapitulatif = (type: number, identifiantArrete?: number) => {
  const params = [`type=${type}`, identifiantArrete && `identifiantArrete=${identifiantArrete}`]
    .filter(Boolean)
    .join('&');

  return `${baseUrl}/editions/recapitulatif?${params}`;
};

export const getEtatRecapitulatif = ({
  type,
  dateDebut,
  dateFin,
  identifiantRegisseurFilter,
  detailParJournee,
}: {
  type: string;
  dateDebut: string;
  dateFin: string;
  identifiantRegisseurFilter?: number | null;
  detailParJournee: boolean;
}) => {
  const params = [
    `type=${encodeURIComponent(type)}`,
    `dateDebut=${dateDebut}`,
    `dateFin=${dateFin}`,
    identifiantRegisseurFilter != null &&
      `identifiantRegisseurFilter=${identifiantRegisseurFilter}`,
    `detailParJournee=${detailParJournee ? 'true' : 'false'}`,
  ]
    .filter(Boolean)
    .join('&');

  return `${baseUrl}/editions/recapitulatif?${params}`;
};

export const getBordereauVersementVolatile = ({
  dateDebut,
  dateFin,
  identifiantRegisseur,
  codesModesReglement,
}: {
  dateDebut: string;
  dateFin: string;
  identifiantRegisseur?: number | null;
  codesModesReglement: string[];
}) => {
  const params = [
    `dateDebut=${dateDebut}`,
    `dateFin=${dateFin}`,
    identifiantRegisseur != null && `identifiantRegisseur=${identifiantRegisseur}`,
    ...codesModesReglement.map((code) => `codesModesReglement[]=${encodeURIComponent(code)}`),
  ]
    .filter(Boolean)
    .join('&');

  return `${baseUrl}/editions/bordereaux-versements-volatile?${params}`;
};
